import { createReducer } from '../../helpers/reducers';

import { types as typesEvents } from '../../actions/events';
import views from '../../routes/views';
import * as typesRoutes from '../../routes/types';

const initialState = 'Simplify Tickets';

const setTitle = title => title;

const handleRoute = title => () => setTitle(title);

const handleEventsShow = (state, action) => {
  const { data } = action.payload;

  return setTitle(data.name);
};

const handleSearchQuery = (state, action) =>
  setTitle(`"${action.payload.queryText}" - Search Results`);

const defaultHandler = (state, action) => {
  if (action.type.indexOf('route/') === 0) {
    const title = views[action.type].pageTitle;
    return title ? title : state;
  }

  return state;
};

const handlers = {
  [typesRoutes.ROUTE_HOME]: () => initialState,
  [typesRoutes.ROUTE_EVENTS]: handleRoute('Events'),
  [typesRoutes.ROUTE_SEARCH_QUERY_TEXT]: handleSearchQuery,

  [typesEvents.EVENTS_SHOW.SUCCESS]: handleEventsShow,
};


const title = createReducer(initialState, handlers, defaultHandler);

export default title;

export const getAppTitle = state => state.app.title;
export const getAppWindowTitle = (state) => {
  const title = getAppTitle(state);

  if (title === initialState) {
    return initialState;
  }

  return `${title} - ${initialState}`;
};

// We use these types in sagas/app to determine when to change the page title
export const handlerTypes = Object.keys(handlers);



// WEBPACK FOOTER //
// ./src/reducers/app/title.js